(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["GD-clickable-map"] && !Shopify.designMode) return;
  try {
    
(function () {
  function collapse(item) {
    item.classList.remove('active');
    var c = item.querySelector('.accordion-content');
    var caret = item.querySelector('.down-caret');
    var header = item.querySelector('.accordion-header');
    if (c) { c.style.height = '0'; c.setAttribute('aria-hidden', 'true'); }
    if (caret) caret.style.transform = 'rotate(0deg)';
    if (header) header.setAttribute('aria-expanded', 'false');
  }

  function expand(item) {
    item.classList.add('active');
    var c = item.querySelector('.accordion-content');
    var caret = item.querySelector('.down-caret');
    var header = item.querySelector('.accordion-header');
    if (c) { c.style.height = c.scrollHeight + 'px'; c.setAttribute('aria-hidden', 'false'); }
    if (caret) caret.style.transform = 'rotate(180deg)';
    if (header) header.setAttribute('aria-expanded', 'true');
  }

  function collapseAll(container) {
    container.querySelectorAll('.accordion-item.active').forEach(collapse);
  }

  function initMap(container) {
    if (container.__gdMapBound) return;
    container.__gdMapBound = true;

    var svg = container.querySelector('.gd-map__svg');
    var tip = container.querySelector('.gd-map__tooltip');
    var items = Array.prototype.slice.call(
      container.querySelectorAll('.gd-map__accordion .accordion-item')
    );
    var openFirst = container.getAttribute('data-open-first') === 'true';

    var byState = {};
    items.forEach(function (it) {
      var code = it.getAttribute('data-state');
      if (code) byState[code] = it;
    });

    /* Accordion header toggles (single-open) */
    items.forEach(function (it, i) {
      var header = it.querySelector('.accordion-header');
      if (!header) return;
      header.addEventListener('click', function () {
        var isActive = it.classList.contains('active');
        collapseAll(container);
        if (!isActive) expand(it);
      });
      if (openFirst && i === 0) expand(it);
    });

    /* Wire up only the states that have a matching block */
    if (svg) {
      Object.keys(byState).forEach(function (code) {
        var item = byState[code];
        var paths = svg.querySelectorAll('path[data-id="' + code + '"]');
        Array.prototype.forEach.call(paths, function (p) {
          p.classList.add('gd-map__state--active');
          var label = item.getAttribute('data-label') || p.getAttribute('data-name') || code;

          p.addEventListener('mousemove', function (e) {
            if (!tip) return;
            tip.textContent = label;
            tip.style.left = e.clientX + 'px';
            tip.style.top = e.clientY + 'px';
            tip.classList.add('is-visible');
          });
          p.addEventListener('mouseleave', function () {
            if (tip) tip.classList.remove('is-visible');
          });
          p.addEventListener('click', function () {
            collapseAll(container);
            expand(item);
            if (tip) tip.classList.remove('is-visible');
            item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        });
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.gd-map').forEach(initMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector && e.target.querySelector('.gd-map');
    if (c) { c.__gdMapBound = false; initMap(c); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.gd-map__item') : null;
    if (!item) return;
    var container = item.closest('.gd-map');
    if (container) { collapseAll(container); expand(item); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["GD-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Both players mute themselves when they judge that unmuted autoplay would
  // be blocked — Chrome only grants it once a site has built up enough Media
  // Engagement, which a new store has not. `muted=0` in the URL is a request,
  // not a guarantee, so once the player reports ready we tell it to unmute
  // over its postMessage API. This avoids loading either vendor's ~40KB
  // player SDK just to flip one switch.
  var vimeoListenerBound = false;

  function bindVimeoUnmute() {
    if (vimeoListenerBound) return;
    vimeoListenerBound = true;

    window.addEventListener('message', function (e) {
      if (!/^https:\/\/player\.vimeo\.com/.test(e.origin)) return;
      var data;
      try {
        data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
      } catch (err) {
        return;
      }
      if (!data || data.event !== 'ready' || !e.source) return;

      ['setMuted', 'setVolume', 'play'].forEach(function (method) {
        var msg = { method: method };
        if (method === 'setMuted') msg.value = false;
        if (method === 'setVolume') msg.value = 1;
        e.source.postMessage(JSON.stringify(msg), e.origin);
      });
    });
  }

  function unmuteYouTube(iframe) {
    function send(func) {
      try {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: func, args: [] }),
          'https://www.youtube.com'
        );
      } catch (err) {}
    }
    iframe.addEventListener('load', function () {
      send('unMute');
      send('setVolume');
      send('playVideo');
    });
  }

  // Fills any slide without a merchant cover image using the video's own
  // thumbnail. YouTube's is at a predictable URL; Vimeo needs its oEmbed
  // endpoint, which allows cross-origin GETs. Failures are left alone — the
  // tinted panel and play button are a fine fallback.
  function loadThumb(btn) {
    var slot = btn.querySelector('[data-gd-vs-thumb]');
    if (!slot || slot.__gdVsThumbDone) return;
    slot.__gdVsThumbDone = true;

    var id = btn.dataset.videoId;
    var provider = btn.dataset.provider;
    if (!id) return;

    function set(url) {
      if (url) slot.style.backgroundImage = 'url("' + url + '")';
    }

    if (provider === 'youtube') {
      // hqdefault always exists; maxresdefault is missing on many uploads.
      set('https://i.ytimg.com/vi/' + id + '/hqdefault.jpg');
      return;
    }

    if (provider === 'vimeo') {
      fetch('https://vimeo.com/api/oembed.json?url=https%3A%2F%2Fvimeo.com%2F' + encodeURIComponent(id) + '&width=1280')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { if (data) set(data.thumbnail_url); })
        .catch(function () {});
    }
  }

  function setup(root) {
    if (root.__gdVsBound) return;
    root.__gdVsBound = true;

    root.querySelectorAll('[data-gd-vs-play]').forEach(loadThumb);

    // Swap the poster for a real iframe on click, and stop any other slide
    // that's already playing so two videos can't talk over each other.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-gd-vs-play]') : null;
      if (!btn || !root.contains(btn)) return;

      root.querySelectorAll('iframe[data-gd-vs-iframe]').forEach(function (f) {
        var frame = f.parentNode;
        f.remove();
        var poster = frame.querySelector('[data-gd-vs-play]');
        if (poster) poster.hidden = false;
      });

      var frame = btn.closest('[data-gd-vs-frame]');
      if (!frame) return;
      var iframe = document.createElement('iframe');
      iframe.setAttribute('data-gd-vs-iframe', '');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', btn.dataset.title || 'Video');

      if (btn.dataset.provider === 'vimeo') bindVimeoUnmute();
      else if (btn.dataset.provider === 'youtube') unmuteYouTube(iframe);

      iframe.src = btn.dataset.src;
      frame.appendChild(iframe);
      btn.hidden = true;
    });
  }

  function mount(root) {
    setup(root);
    if (root.__gdVsSplide || typeof Splide === 'undefined') return;

    var perView = parseFloat(root.dataset.perView) || 1;
    var perTablet = parseFloat(root.dataset.perViewTablet) || perView;
    var perMobile = parseFloat(root.dataset.perViewMobile) || 1;
    var gap = parseInt(root.dataset.gap, 10);
    if (isNaN(gap)) gap = 16;

    var splide = new Splide(root, {
      perPage: perView,
      perMove: 1,
      gap: gap + 'px',
      arrows: root.dataset.arrows === 'true',
      pagination: root.dataset.pagination === 'true',
      loop: root.dataset.loop === 'true',
      // Dragging inside an iframe never reaches us anyway, but this keeps the
      // poster area from feeling like a drag surface.
      drag: true,
      // Splide builds the pagination itself, so the color scheme class has to
      // be handed to it here rather than set in the markup.
      classes: {
        pagination: 'splide__pagination' + (root.dataset.navScheme ? ' color-' + root.dataset.navScheme : '')
      },
      breakpoints: {
        989: { perPage: perTablet },
        749: { perPage: perMobile }
      }
    });

    // Moving the slider tears down any playing iframe, matching how the rest
    // of the theme's sliders stop media when a slide leaves.
    splide.on('move', function () {
      root.querySelectorAll('iframe[data-gd-vs-iframe]').forEach(function (f) {
        var frame = f.parentNode;
        f.remove();
        var poster = frame.querySelector('[data-gd-vs-play]');
        if (poster) poster.hidden = false;
      });
    });

    splide.mount();
    root.__gdVsSplide = splide;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gd-vs]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
